module.exports = __webpack_public_path__ + "img/r1.5700a671.jpg";